// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-maroon {
  color: #8b0166 !important;
}

.border-maroon {
  border-color: #D099C2 !important;
}

.subjects-header {
  position: relative;
  padding: 5px 0;
  background: #00a881;
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.1607843137) !important;
}
.subjects-header .visitDate,
.subjects-header .visitChapter {
  color: #ffffff;
  border-radius: 5px;
}
.subjects-header .visitDate i,
.subjects-header .visitChapter i {
  font-size: 1.4rem;
}
.subjects-header.chemistry {
  background: #0060ce;
}
.subjects-header.physics {
  background: #feaf55;
}
.subjects-header.botany {
  background: #3d8815;
}
.subjects-header.zoology {
  background: #C37800;
}
.subjects-header.maths {
  background: #707070;
}

.custom-popover {
  border-radius: 6px;
}
.custom-popover .popover-body {
  overflow: hidden;
}
.custom-popover .popover-body form .form-group:last-child {
  margin-bottom: 0;
}
.custom-popover .popover-body button {
  color: #212529;
}

.concept_cards .single_concept .icon-indicator {
  position: absolute;
  right: 0;
  bottom: 0;
}
.concept_cards .single_concept .helpTags li i {
  cursor: pointer;
}

.shortNote .concept_cards .single_concept .card-body {
  overflow: hidden;
  position: relative;
  height: 96px;
  padding-top: 0.5rem !important;
  margin-bottom: 0.5rem;
}

.singleshortNote .pagination button {
  color: #2091E9;
  background: rgba(32, 145, 233, 0.1607843137);
  border: 1px solid #2091E9;
  border-radius: 25px;
}

.subject_section {
  position: relative;
}
.subject_section .chapter-block a:hover .card {
  background: #e9ecef;
}
.subject_section .sortingDropdown .dropdown-toggle {
  color: #121412;
  background-color: #ffffff;
  border: 1px solid #D5D5D5;
}
.subject_section .sortingDropdown .dropdown-toggle:active {
  color: #121412;
  background-color: #ffffff;
  border: 1px solid #D5D5D5;
}
.subject_section .sortingDropdown .dropdown-item {
  width: auto;
}
.subject_section a {
  color: #212529;
  text-decoration: none;
}
.subject_section .cardrows .card.subject-card {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
  border-radius: 6px;
}
.subject_section .cardrows .card.subject-card .card-header {
  box-shadow: 0px -5px 20px rgba(0, 0, 0, 0.0509803922);
  border-radius: 6px;
}
.subject_section .cardrows .card.subject-card .card-header a {
  color: #212529;
  text-decoration: none;
}
.subject_section .cardrows .card.subject-card .card-header a .counter {
  margin-top: 4px;
  width: 35px;
  height: 35px;
  color: #00C596;
  background: #FFFFFF;
  text-align: center;
  line-height: 35px;
  border: 1px solid #D7F4DD;
  border-radius: 6px;
}
.subject_section .cardrows .card.subject-card .card-header a h6.title {
  font: 600 15px/16px "proxima-nova", sans-serif;
  text-transform: uppercase;
  height: 40px;
}
.subject_section .cardrows .card.subject-card .card-header a p {
  font: 400 13px/15px "proxima-nova", sans-serif;
  color: #B7B7B7;
}
.subject_section .cardrows .card.subject-card .card-body {
  position: relative;
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills {
  margin: 0;
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item {
  margin: 0;
  width: 21%;
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item .nav-link {
  color: #212529;
  background-color: #ffffff;
  border: 1px solid #D5D5D5;
  border-radius: 3px;
  padding: 0.4rem 0.2rem;
  margin: 2px;
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item .nav-link span {
  font-size: 12px;
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.graph .nav-link:hover, .subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.graph .nav-link.active {
  color: #5d636b;
  background: #eaeaea;
  border: 1px solid #D5D5D5;
  border-radius: 3px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.learn .nav-link {
  color: #f8b642;
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.learn .nav-link:hover, .subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.learn .nav-link.active {
  color: #f8b642;
  background: #fef5e6;
  border: 1px solid #f7c772;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.practice .nav-link {
  color: #6ab879;
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.practice .nav-link:hover, .subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.practice .nav-link.active {
  color: #6ab879;
  background: #d7f4dd;
  border: 1px solid #8fdc9e;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.practice .nav-link i {
  color: #a2c7ff;
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.error .nav-link:hover, .subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.error .nav-link.active {
  color: #fa576a;
  background: #fde6e7;
  border: 1px solid #fac7cd;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
}
.subject_section .cardrows .card.subject-card .card-body .card-header-pills .nav-item.error .nav-link i {
  color: #fa576a;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content {
  padding: 0;
  position: relative;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content h6 {
  font-size: 14px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .border_pad {
  border: 1px solid #EEEEEE;
  border-radius: 5px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .border_pad p {
  color: rgba(99, 63, 210, 0.59);
  font-size: 12px;
  text-align: center;
  margin-top: 5px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .border_pad p span {
  color: #633FD2;
  font-weight: bold;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content {
  height: 11.2rem;
  padding-top: 6px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card {
  height: 9rem;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .right-answer {
  text-align: center;
  color: #3cbb95;
  background: #D7F4DD;
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .wrong-answer {
  text-align: center;
  color: #fa576a;
  background: #fde6e7;
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-primary {
  border: 1px solid #A6D3F6 !important;
  border-radius: 5px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-primary .card-body span {
  font: 600 16px/39px "proxima-nova", sans-serif;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-primary P {
  padding: 10px 0;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-primary .card-footer {
  text-align: center;
  background: #A5D3F6 !important;
  border: 1px solid #A6D3F6 !important;
  border-radius: 5px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-primary .card-footer a {
  color: #2091E9;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-success {
  border: 1px solid #99E8D5 !important;
  border-radius: 5px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-success .card-body span {
  font: 600 16px/39px "proxima-nova", sans-serif;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-success P {
  padding-top: 4px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-success .card-footer {
  text-align: center;
  background: #b0ebdd !important;
  border: 1px solid #99E8D5 !important;
  border-radius: 5px;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .content .card-box .card.border-success .card-footer a {
  color: #00ac84 !important;
  opacity: 0.8;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom {
  text-align: center;
  padding: 6px 2px;
  border-radius: 4px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom.dashboard {
  background: #f0edfa;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom.dashboard a {
  font-weight: 600;
  color: #633FD2;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom.learn {
  background: #fef5e6;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom.learn a {
  font-weight: 600;
  color: #f8b642;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom.practice {
  background: #d7f4dd;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom.practice a {
  font-weight: 600;
  color: #3cbb95;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom.error {
  background: #ffefef;
}
.subject_section .cardrows .card.subject-card .card-body .tab-content .card-bottom.error a {
  font-weight: 600;
  color: #cb3f3f;
}
.subject_section .topic_cards .single_topic {
  margin-bottom: 2rem;
}
.subject_section .topic_cards .single_topic a {
  text-decoration: none;
  color: #121412;
}
.subject_section .topic_cards .single_topic a .card {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.0509803922);
  border: 1px solid #D7F4DD;
}
.subject_section .topic_cards .single_topic a .card .cout {
  width: 35px;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  color: #00c596;
  background: #ffffff;
  border: 1px solid #dfffe6;
  text-align: center;
  border-radius: 5px;
}
.subject_section .topic_cards .single_topic a .card h5 {
  position: relative;
  padding-left: 20px;
  font-size: 18px;
  font-weight: 600;
}
.subject_section .RevisionMaterial.nav-pills {
  background: #F1F1F1;
}
.subject_section .RevisionMaterial.nav-pills .nav-item {
  position: relative;
  flex: 1 1 auto;
  text-align: center;
  margin-bottom: 0;
}
.subject_section .RevisionMaterial.nav-pills .nav-item .nav-link {
  position: relative;
  font-weight: 500;
  color: #5d5f61;
  border-radius: 0;
}
.subject_section .RevisionMaterial.nav-pills .nav-item .nav-link:before {
  content: "";
  height: 1.5rem;
  width: 1px;
  background: #D5D5D5;
  position: absolute;
  right: 0;
}
.subject_section .RevisionMaterial.nav-pills .nav-item:last-child .nav-link::before {
  display: none;
}
.subject_section .RevisionMaterial.nav-pills .nav-link.active,
.subject_section .RevisionMaterial.nav-pills .nav-link:focus,
.subject_section .RevisionMaterial.nav-pills .nav-item.show .nav-link {
  font-weight: 600;
  color: #121412;
  background-color: transparent;
  border-bottom: 2px solid #00C596 !important;
}
.subject_section .RevisionMaterial.nav-pills .tab-content {
  margin-top: 1rem;
}
.subject_section .WatchingVideos {
  position: relative;
}
.subject_section .WatchingVideos .card {
  overflow: hidden;
  border-radius: 6px;
}
.subject_section .WatchingVideos .card .bg-blur {
  background: hsla(0, 0%, 0%, 0.5) !important;
}
.subject_section .WatchingVideos .card .content .card-title {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
}
.subject_section .WatchingVideos .card .content .d-flex .videodurations {
  padding: 2px 4px;
  background: #202B63;
  border-radius: 6px 0;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/_subjects.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,+DAAA;AACJ;AACI;;EAEI,cAAA;EACA,kBAAA;AACR;AACQ;;EACI,iBAAA;AAEZ;AAEI;EACI,mBAAA;AAAR;AAGI;EACI,mBAAA;AADR;AAII;EACI,mBAAA;AAFR;AAKI;EACI,mBAAA;AAHR;AAMI;EACI,mBAAA;AAJR;;AAQA;EACI,kBAAA;AALJ;AAOI;EACI,gBAAA;AALR;AAOQ;EACI,gBAAA;AALZ;AAQQ;EACI,cAAA;AANZ;;AAYI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AATR;AAYI;EACI,eAAA;AAVR;;AAeI;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;AAZR;;AA2BI;EACI,cAAA;EACA,4CAAA;EACA,yBAAA;EACA,mBAAA;AAxBR;;AA4BA;EACI,kBAAA;AAzBJ;AA4BQ;EACI,mBAAA;AA1BZ;AA+BQ;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;AA7BZ;AA+BY;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;AA7BhB;AAiCQ;EACI,WAAA;AA/BZ;AAmCI;EACI,cAAA;EACA,qBAAA;AAjCR;AAoCI;EACI,oDAAA;EACA,kBAAA;AAlCR;AAoCQ;EACI,qDAAA;EACA,kBAAA;AAlCZ;AAoCY;EACI,cAAA;EACA,qBAAA;AAlChB;AAoCgB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAlCpB;AAqCgB;EACI,8CAAA;EACA,yBAAA;EACA,YAAA;AAnCpB;AA2CgB;EACI,8CAAA;EACA,cAAA;AAzCpB;AA8CQ;EACI,kBAAA;AA5CZ;AA+CY;EACI,SAAA;AA7ChB;AA+CgB;EACI,SAAA;EACA,UAAA;AA7CpB;AA+CoB;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AA7CxB;AA+CwB;EACI,eAAA;AA7C5B;AAqDgB;EAEI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oDAAA;AApDpB;AAwDY;EACI,cAAA;AAtDhB;AAwDgB;EAEI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,oDAAA;AAvDpB;AA2DY;EACI,cAAA;AAzDhB;AA2DgB;EAEI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,oDAAA;AA1DpB;AA6DgB;EACI,cAAA;AA3DpB;AAiEgB;EAEI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,oDAAA;AAhEpB;AAmEgB;EACI,cAAA;AAjEpB;AAqEY;EACI,UAAA;EACA,kBAAA;AAnEhB;AAqEgB;EACI,eAAA;AAnEpB;AAsEgB;EACI,yBAAA;EACA,kBAAA;AApEpB;AAsEoB;EACI,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AApExB;AAsEwB;EACI,cAAA;EACA,iBAAA;AApE5B;AAyEgB;EACI,eAAA;EAGA,gBAAA;AAzEpB;AA2EoB;EACI,YAAA;AAzExB;AA4EoB;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AA1ExB;AA6EoB;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AA3ExB;AA8EoB;EACI,oCAAA;EACA,kBAAA;AA5ExB;AA8EwB;EACI,8CAAA;AA5E5B;AA+EwB;EACI,eAAA;AA7E5B;AAgFwB;EACI,kBAAA;EACA,8BAAA;EACA,oCAAA;EACA,kBAAA;AA9E5B;AAgF4B;EACI,cAAA;AA9EhC;AAmFoB;EACI,oCAAA;EACA,kBAAA;AAjFxB;AAmFwB;EACI,8CAAA;AAjF5B;AAoFwB;EACI,gBAAA;AAlF5B;AAqFwB;EACI,kBAAA;EACA,8BAAA;EACA,oCAAA;EACA,kBAAA;AAnF5B;AAqF4B;EAEI,yBAAA;EACA,YAAA;AApFhC;AA0FgB;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AAxFpB;AA2FgB;EACI,mBAAA;AAzFpB;AA2FoB;EACI,gBAAA;EACA,cAAA;AAzFxB;AA6FgB;EACI,mBAAA;AA3FpB;AA6FoB;EACI,gBAAA;EACA,cAAA;AA3FxB;AA+FgB;EACI,mBAAA;AA7FpB;AA+FoB;EACI,gBAAA;EACA,cAAA;AA7FxB;AAiGgB;EACI,mBAAA;AA/FpB;AAkGoB;EACI,gBAAA;EACA,cAAA;AAhGxB;AAuGI;EACI,mBAAA;AArGR;AAuGQ;EACI,qBAAA;EACA,cAAA;AArGZ;AAuGY;EACI,oDAAA;EACA,yBAAA;AArGhB;AAuGgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AArGpB;AAwGgB;EACI,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAtGpB;AA4GI;EACI,mBAAA;AA1GR;AA4GQ;EACI,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA1GZ;AA4GY;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA1GhB;AA4GgB;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AA1GpB;AA+GgB;EACI,aAAA;AA7GpB;AAkHQ;;;EAGI,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,2CAAA;AAhHZ;AAmHQ;EACI,gBAAA;AAjHZ;AAsHI;EACI,kBAAA;AApHR;AAsHQ;EACI,gBAAA;EACA,kBAAA;AApHZ;AAsHY;EACI,2CAAA;AApHhB;AA8HgB;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA5HpB;AA+HgB;EACI,gBAAA;EACA,mBAAA;EACA,oBAAA;AA7HpB","sourcesContent":[".text-maroon {\n    color: #8b0166 !important;\n}\n\n.border-maroon {\n    border-color: #D099C2 !important;\n}\n\n.subjects-header {\n    position: relative;\n    padding: 5px 0;\n    background: #00a881;\n    box-shadow: 0px 3px 16px #00000029 !important;\n\n    .visitDate,\n    .visitChapter {\n        color: #ffffff;\n        border-radius: 5px;\n\n        i {\n            font-size: 1.4rem;\n        }\n    }\n\n    &.chemistry {\n        background: #0060ce;\n    }\n\n    &.physics {\n        background: #feaf55\n    }\n\n    &.botany {\n        background: #3d8815;\n    }\n\n    &.zoology {\n        background: #C37800;\n    }\n\n    &.maths {\n        background: #707070;\n    }\n}\n\n.custom-popover {\n    border-radius: 6px;\n\n    .popover-body {\n        overflow: hidden;\n\n        form .form-group:last-child {\n            margin-bottom: 0;\n        }\n\n        button {\n            color: #212529;\n        }\n    }\n}\n\n.concept_cards .single_concept {\n    .icon-indicator {\n        position: absolute;\n        right: 0;\n        bottom: 0;\n    }\n\n    .helpTags li i {\n        cursor: pointer;\n    }\n}\n\n.shortNote .concept_cards .single_concept {\n    .card-body {\n        overflow: hidden;\n        position: relative;\n        height: 96px;\n        padding-top: 0.5rem !important;\n        margin-bottom: 0.5rem;\n\n        // &::before {\n        //     content: '';\n        //     position: absolute;\n        //     left: 0;\n        //     bottom: 0;\n        //     width: 100%;\n        //     height: 42%;\n        //     background: linear-gradient(to bottom, transparent 20%, rgba(255, 255, 255, 0.9) 50%, #ffffff 100%)\n        // }\n    }\n}\n\n.singleshortNote .pagination {\n    button {\n        color: #2091E9;\n        background: #2091E929;\n        border: 1px solid #2091E9;\n        border-radius: 25px;\n    }\n}\n\n.subject_section {\n    position: relative;\n\n    .chapter-block {\n        a:hover .card {\n            background: #e9ecef;\n        }\n    }\n\n    .sortingDropdown {\n        .dropdown-toggle {\n            color: #121412;\n            background-color: #ffffff;\n            border: 1px solid #D5D5D5;\n\n            &:active {\n                color: #121412;\n                background-color: #ffffff;\n                border: 1px solid #D5D5D5;\n            }\n        }\n\n        .dropdown-item {\n            width: auto;\n        }\n    }\n\n    a {\n        color: #212529;\n        text-decoration: none;\n    }\n\n    .cardrows .card.subject-card {\n        box-shadow: 0px 3px 10px #0000000D;\n        border-radius: 6px;\n\n        .card-header {\n            box-shadow: 0px -5px 20px #0000000D;\n            border-radius: 6px;\n\n            a {\n                color: #212529;\n                text-decoration: none;\n\n                .counter {\n                    margin-top: 4px;\n                    width: 35px;\n                    height: 35px;\n                    color: #00C596;\n                    background: #FFFFFF;\n                    text-align: center;\n                    line-height: 35px;\n                    border: 1px solid #D7F4DD;\n                    border-radius: 6px;\n                }\n\n                h6.title {\n                    font: 600 15px/16px 'proxima-nova', sans-serif;\n                    text-transform: uppercase;\n                    height: 40px;\n                    // font: 600 16px/25px 'proxima-nova', sans-serif;\n                    // text-transform: capitalize;\n                    // white-space: nowrap;\n                    // overflow: hidden;\n                    // text-overflow: ellipsis;\n                }\n\n                p {\n                    font: 400 13px/15px 'proxima-nova', sans-serif;\n                    color: #B7B7B7;\n                }\n            }\n        }\n\n        .card-body {\n            position: relative;\n\n\n            .card-header-pills {\n                margin: 0;\n\n                .nav-item {\n                    margin: 0;\n                    width: 21%;\n\n                    .nav-link {\n                        color: #212529;\n                        background-color: #ffffff;\n                        border: 1px solid #D5D5D5;\n                        border-radius: 3px;\n                        padding: .4rem 0.2rem;\n                        margin: 2px;\n\n                        span {\n                            font-size: 12px;\n                        }\n                    }\n                }\n            }\n\n            .card-header-pills .nav-item.graph .nav-link {\n\n                &:hover,\n                &.active {\n                    color: #5d636b;\n                    background: #eaeaea;\n                    border: 1px solid #D5D5D5;\n                    border-radius: 3px;\n                    box-shadow: 0px 3px 10px #0000000D;\n                }\n            }\n\n            .card-header-pills .nav-item.learn .nav-link {\n                color: #f8b642;\n\n                &:hover,\n                &.active {\n                    color: #f8b642;\n                    background: #fef5e6;\n                    border: 1px solid #f7c772;\n                    box-shadow: 0px 3px 10px #0000000D;\n                }\n            }\n\n            .card-header-pills .nav-item.practice .nav-link {\n                color: #6ab879;\n\n                &:hover,\n                &.active {\n                    color: #6ab879;\n                    background: #d7f4dd;\n                    border: 1px solid #8fdc9e;\n                    box-shadow: 0px 3px 10px #0000000D;\n                }\n\n                i {\n                    color: #a2c7ff;\n                }\n            }\n\n            .card-header-pills .nav-item.error .nav-link {\n\n                &:hover,\n                &.active {\n                    color: #fa576a;\n                    background: #fde6e7;\n                    border: 1px solid #fac7cd;\n                    box-shadow: 0px 3px 10px #0000000D;\n                }\n\n                i {\n                    color: #fa576a;\n                }\n            }\n\n            .tab-content {\n                padding: 0;\n                position: relative;\n\n                h6 {\n                    font-size: 14px;\n                }\n\n                .border_pad {\n                    border: 1px solid #EEEEEE;\n                    border-radius: 5px;\n\n                    p {\n                        color: rgba(99, 63, 210, 0.59);\n                        font-size: 12px;\n                        text-align: center;\n                        margin-top: 5px;\n\n                        span {\n                            color: #633FD2;\n                            font-weight: bold;\n                        }\n                    }\n                }\n\n                .content {\n                    height: 11.2rem;\n                    // height: 14rem;\n                    // margin-bottom: 30px;\n                    padding-top: 6px;\n\n                    .card-box .card {\n                        height: 9rem;\n                    }\n\n                    .right-answer {\n                        text-align: center;\n                        color: #3cbb95;\n                        background: #D7F4DD;\n                        border-radius: 5px;\n                        height: 40px;\n                        line-height: 40px;\n                    }\n\n                    .wrong-answer {\n                        text-align: center;\n                        color: #fa576a;\n                        background: #fde6e7;\n                        border-radius: 5px;\n                        height: 40px;\n                        line-height: 40px;\n                    }\n\n                    .card-box .card.border-primary {\n                        border: 1px solid #A6D3F6 !important;\n                        border-radius: 5px;\n\n                        .card-body span {\n                            font: 600 16px/39px 'proxima-nova', sans-serif;\n                        }\n\n                        P {\n                            padding: 10px 0;\n                        }\n\n                        .card-footer {\n                            text-align: center;\n                            background: #A5D3F6 !important;\n                            border: 1px solid #A6D3F6 !important;\n                            border-radius: 5px;\n\n                            a {\n                                color: #2091E9;\n                            }\n                        }\n                    }\n\n                    .card-box .card.border-success {\n                        border: 1px solid #99E8D5 !important;\n                        border-radius: 5px;\n\n                        .card-body span {\n                            font: 600 16px/39px 'proxima-nova', sans-serif;\n                        }\n\n                        P {\n                            padding-top: 4px;\n                        }\n\n                        .card-footer {\n                            text-align: center;\n                            background: #b0ebdd !important;\n                            border: 1px solid #99E8D5 !important;\n                            border-radius: 5px;\n\n                            a {\n                                // font: 500 12px/15px 'proxima-nova', sans-serif;\n                                color: #00ac84 !important;\n                                opacity: 0.8;\n                            }\n                        }\n                    }\n                }\n\n                .card-bottom {\n                    text-align: center;\n                    padding: 6px 2px;\n                    border-radius: 4px;\n                    width: 100%;\n                    position: absolute;\n                    bottom: 0;\n                    left: 0;\n                }\n\n                .card-bottom.dashboard {\n                    background: #f0edfa;\n\n                    a {\n                        font-weight: 600;\n                        color: #633FD2;\n                    }\n                }\n\n                .card-bottom.learn {\n                    background: #fef5e6;\n\n                    a {\n                        font-weight: 600;\n                        color: #f8b642;\n                    }\n                }\n\n                .card-bottom.practice {\n                    background: #d7f4dd;\n\n                    a {\n                        font-weight: 600;\n                        color: #3cbb95;\n                    }\n                }\n\n                .card-bottom.error {\n                    background: #ffefef;\n\n\n                    a {\n                        font-weight: 600;\n                        color: #cb3f3f;\n                    }\n                }\n            }\n        }\n    }\n\n    .topic_cards .single_topic {\n        margin-bottom: 2rem;\n\n        a {\n            text-decoration: none;\n            color: #121412;\n\n            .card {\n                box-shadow: 0px 3px 20px #0000000D;\n                border: 1px solid #D7F4DD;\n\n                .cout {\n                    width: 35px;\n                    height: 35px;\n                    line-height: 35px;\n                    font-size: 16px;\n                    color: #00c596;\n                    background: #ffffff;\n                    border: 1px solid #dfffe6;\n                    text-align: center;\n                    border-radius: 5px;\n                }\n\n                h5 {\n                    position: relative;\n                    padding-left: 20px;\n                    font-size: 18px;\n                    font-weight: 600;\n                }\n            }\n        }\n    }\n\n    .RevisionMaterial.nav-pills {\n        background: #F1F1F1;\n\n        .nav-item {\n            position: relative;\n            flex: 1 1 auto;\n            text-align: center;\n            margin-bottom: 0;\n\n            .nav-link {\n                position: relative;\n                font-weight: 500;\n                color: #5d5f61;\n                border-radius: 0;\n\n                &:before {\n                    content: '';\n                    height: 1.5rem;\n                    width: 1px;\n                    background: #D5D5D5;\n                    position: absolute;\n                    right: 0;\n                }\n            }\n\n            &:last-child {\n                .nav-link::before {\n                    display: none;\n                }\n            }\n        }\n\n        .nav-link.active,\n        .nav-link:focus,\n        .nav-item.show .nav-link {\n            font-weight: 600;\n            color: #121412;\n            background-color: transparent;\n            border-bottom: 2px solid #00C596 !important;\n        }\n\n        .tab-content {\n            margin-top: 1rem;\n        }\n\n    }\n\n    .WatchingVideos {\n        position: relative;\n\n        .card {\n            overflow: hidden;\n            border-radius: 6px;\n\n            .bg-blur {\n                background: hsla(0, 0%, 0%, 0.5) !important;\n            }\n\n            .content {\n                // position: absolute;\n                // background: hsla(0, 0%, 0%, 0.4);\n                // width: 100%;\n                // bottom: 0;\n                // left: 0;\n\n                .card-title {\n                    font-size: 15px;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                    margin-bottom: 0;\n                }\n\n                .d-flex .videodurations {\n                    padding: 2px 4px;\n                    background:#202B63;\n                    border-radius: 6px 0;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
